import { render } from "./Newsletter.vue?vue&type=template&id=4b708f5c&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=4b708f5c&scoped=true&lang=css"
import "./Newsletter.vue?vue&type=style&index=1&id=4b708f5c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b708f5c"]])

export default __exports__